export default __webpack_public_path__ + "static/media/MatchRiteCare_logo_3Color_White.784d0056.png";